import { runtimeEventManager } from "@wm/core";

runtimeEventManager.on('wms:set-app-defaults').subscribe((data: any) => {
    runtimeEventManager.emit('wms:app-defaults-ready');
});

// returns the value mapped with the key
export function getAppDefault(key: any) {
    let i18nService = runtimeEventManager.getService('i18Services');
    return i18nService.appDefaults[key];
}
